import { KeysOf, ValueOf } from '~types/common';

type LineHeightKeys = KeysOf<typeof lineHeight>;

export type LineHeight = {
  [key in LineHeightKeys]: ValueOf<typeof lineHeight>;
};

const lineHeight = {
  high: '1.5',
  default: '1.2',
};

export default lineHeight;
